"use client";

import * as React from "react";
import { track } from "../../track";
import { NavigationUserEvents } from "../../events/navigation";
import { Routes } from "~/routes";
import { usePathname } from "next/navigation";
import { isNullOrUndefined } from "~/utils/isNullOrUndefined";

// // // //

/**
 * PageTrack
 * Implements page "Page Loaded" event for an individual page
 */
export function PageTrack(props: { route: Routes; children: React.ReactNode }) {
    const pathname = usePathname();
    const { route, children } = props;

    React.useEffect(() => {
        if (isNullOrUndefined(route)) {
            return;
        }

        track(NavigationUserEvents.pageLoaded, {
            path: pathname,
            pathname: route,
        });
    }, [pathname]);

    return <>{children}</>;
}
